package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initContactPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Contact.md", FrontMatterElement.Builder { addScalar("title", "Contact"); addScalar("subtitle", "よくあるご質問・お問い合わせ"); }))
}

@Page("/contact")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun ContactPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("よくあるご質問") }) {
        org.jetbrains.compose.web.dom.Text("よくあるご質問")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("q-チケットを購入しましたが-適格請求書-インボイス-発行事業者の登録番号が領収書に記載されていません-登録番号を教えて下さい") }) {
        org.jetbrains.compose.web.dom.Text("Q. チケットを購入しましたが、適格請求書（インボイス）発行事業者の登録番号が領収書に記載されていません。登録番号を教えて下さい。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A. 日本Kotlinユーザーグループは適格請求書発行事業者登録を行っていないため、適格請求書発行事業者の登録番号が掲載されている請求書の発行はできません。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("q-kotlin-fest関連イベントを企画しています-イベント名に-kotlin-fest-という名前を使用できますか-例-kotlin-festアフターパーティ-等") }) {
        org.jetbrains.compose.web.dom.Text("Q. Kotlin Fest関連イベントを企画しています。イベント名に \"Kotlin Fest\" という名前を使用できますか？（例：『Kotlin Festアフターパーティ』等）")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A. ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("できません。")
        }
        org.jetbrains.compose.web.dom.Text(" Kotlin Festを開催するにあたり、日本KotlinユーザーグループはJetBrains社より \"Kotlin\" というブランド名の使用に関する許諾を受けております。そのため、日本Kotlinユーザーグループが関係しないイベントにて名前を使用することは一律お断りさせていただいております。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("q-ノベルティやcmなどにkotlin-festのロゴを利用したいのですが-可能でしょうか") }) {
        org.jetbrains.compose.web.dom.Text("Q. ノベルティやCMなどにKotlin Festのロゴを利用したいのですが、可能でしょうか？")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A. ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("用途によっては可能です。")
        }
        org.jetbrains.compose.web.dom.Text(" Kotlin Fest 2026のロゴ使用に関して、詳しくは")
        com.varabyte.kobweb.silk.components.navigation.Link("/brand-logo-guidelines") {
            org.jetbrains.compose.web.dom.Text("ガイドライン")
        }
        org.jetbrains.compose.web.dom.Text(" をご参照ください。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("お問い合わせ") }) {
        org.jetbrains.compose.web.dom.Text("お問い合わせ")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("その他、本イベント、サイトに関するお問い合わせは、下記の窓口までお願いいたします。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("住所：〒110-0014 東京都台東区北上野2丁目8-4-501")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("団体名：日本Kotlinユーザーグループ")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("代表：日高 正博")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Eメールアドレス： ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@kotlinfest.dev") {
                org.jetbrains.compose.web.dom.Text("contact@kotlinfest.dev")
            }
        }
    }
}
